
// This page is deprecated. Email verification is no longer required.
export default function Verify() {
  return (
    <div className="page">
      <section className="page-section">
        <h1>Email verification is no longer required.</h1>
        <p>Please return to the login or registration page.</p>
      </section>
    </div>
  );
}
